// テーマ切替（ダーク／明るい）。
// ダーク = 既定（tokens.css の :root）。明るい = data-theme="light" を <html> に付与。
// 選択はユーザーごとに localStorage に永続化する。初期適用は public/index.html の
// インラインスクリプトで描画前に行い、フラッシュ（FOUC）を防ぐ。ここでは React 側の
// 状態管理と、トグル時の即時反映・永続化を担う。
import { useCallback, useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'voilog-theme';

export function getStoredTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme: Theme): void {
  const el = document.documentElement;
  if (theme === 'light') el.setAttribute('data-theme', 'light');
  else el.removeAttribute('data-theme');
}

export function setStoredTheme(theme: Theme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* localStorage 不可（プライベートモード等）でも切替自体は効かせる */
  }
  applyTheme(theme);
}

// テーマ state を返すフック。トグルで即時に DOM 反映＋永続化する。
export function useTheme(): [Theme, (theme: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(getStoredTheme);

  // 初回マウント時に保存値を確実に適用（index.html の事前適用と二重でも冪等）。
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const update = useCallback((next: Theme) => {
    setStoredTheme(next);
    setTheme(next);
  }, []);

  return [theme, update];
}
